export const listaMunicipioStore = {
    namespaced: true,
    state : {
        ListaMunicipio: {},
    },
    mutations : {
        updateStateListaMunicipio(state, payload) {
            state.ListaMunicipio = payload;
        },
    },
    actions : {
        updateStateListaMunicipio({ state, commit }, data) {
            commit('updateStateListaMunicipio', data);
        },
    },
    getters : {
        ListaMunicipio: (state, getters) => {
            return state.ListaMunicipio;
        },   
    }
}